var map = {
	"./cv-builder/banner.png": 7621,
	"./cv-builder/banner.svg": 1148,
	"./cv-builder/landing.svg": 4467,
	"./cv-builder/login.svg": 7353,
	"./cv-builder/mobile-work-exp.svg": 6816,
	"./cv-builder/page1.png": 5632,
	"./cv-builder/page2.png": 3195,
	"./cv-builder/page3.png": 1650,
	"./cv-builder/page4.png": 1629,
	"./cv-builder/personal-info.svg": 7307,
	"./exowem/banner.png": 1356,
	"./exowem/banner.svg": 1366,
	"./exowem/dashboard-giftcard.svg": 65,
	"./exowem/dashboard-offers.svg": 9624,
	"./exowem/dashboard.svg": 6424,
	"./exowem/landing.svg": 6493,
	"./exowem/mobile-dashboard-offers.svg": 5123,
	"./exowem/mobile-landing-night.svg": 1485,
	"./exowem/page1.png": 6074,
	"./exowem/page2.png": 6241,
	"./exowem/page3.png": 2024,
	"./exowem/page4.png": 3543,
	"./exowem/page5.png": 5230,
	"./exowem/page6.png": 2581,
	"./netflix/banner.png": 4963,
	"./netflix/banner.svg": 9443,
	"./netflix/landing.svg": 9450,
	"./netflix/login.svg": 4564,
	"./netflix/mobile-browse.svg": 8274,
	"./netflix/movie-info.svg": 7980,
	"./netflix/page1.png": 8371,
	"./netflix/page2.png": 6392,
	"./netflix/page3.png": 8433,
	"./netflix/page4.png": 222,
	"./netflix/page5.png": 6007,
	"./netflix/user-preview.svg": 2015,
	"./resell-wgh/about.svg": 7886,
	"./resell-wgh/banner.png": 9383,
	"./resell-wgh/banner.svg": 7081,
	"./resell-wgh/features.svg": 6754,
	"./resell-wgh/hero.svg": 8151,
	"./resell-wgh/mobile-about.svg": 9081,
	"./resell-wgh/page1.png": 4903,
	"./resell-wgh/page2.png": 3148,
	"./resell-wgh/page3.png": 9685,
	"./resell-wgh/page4.png": 2810,
	"./tnnafrica/appointment-feature.svg": 4059,
	"./tnnafrica/banner.png": 1509,
	"./tnnafrica/banner.svg": 7849,
	"./tnnafrica/contact.svg": 9629,
	"./tnnafrica/landing.svg": 208,
	"./tnnafrica/mobile-contact.svg": 3334,
	"./tnnafrica/page1.png": 5669,
	"./tnnafrica/page2.png": 7518,
	"./tnnafrica/page3.png": 6887,
	"./tnnafrica/page4.png": 5368,
	"./tnnafrica/page5.png": 9985,
	"./tnnafrica/speak-to-us.svg": 5672,
	"./vankwallet/banner.png": 6734,
	"./vankwallet/mobile.png": 750,
	"./vankwallet/page1.png": 2204,
	"./vankwallet/page2.png": 2263,
	"./vankwallet/page3.png": 3950,
	"./vankwallet/page4.png": 4961,
	"./vankwallet/page5.png": 7096,
	"./wgh-reseller-site/banner.png": 4430,
	"./wgh-reseller-site/banner.svg": 4766,
	"./wgh-reseller-site/dashboard.svg": 3552,
	"./wgh-reseller-site/domain-search.svg": 4509,
	"./wgh-reseller-site/hosting-plans.svg": 1625,
	"./wgh-reseller-site/landing.svg": 6149,
	"./wgh-reseller-site/mobile-domain-transfer.svg": 8622,
	"./wgh-reseller-site/page1.png": 1932,
	"./wgh-reseller-site/page2.png": 2615,
	"./wgh-reseller-site/page3.png": 6830,
	"./wgh-reseller-site/page4.png": 1393,
	"./wgh-reseller-site/page5.png": 3000,
	"./wgh-reseller-site/page6.png": 4979,
	"./wgh-reseller-site/services.svg": 3252
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6695;